import React from 'react'
import Grid from '../../../common/components/Grid'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import Menu, {MenuItem} from 'material-ui/Menu'
import {ListItemSecondaryAction} from 'material-ui/List'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui-icons/MoreVert'
import TextField from 'material-ui/TextField'
import Dialog, {DialogActions, DialogContent, DialogContentText, DialogTitle} from 'material-ui/Dialog'
import {Link, Panel, PanelItem, PanelItemText} from '../../../components'
import {addresses as text} from '../text'
import LoadingButton from '../../../common/components/LoadingButton'
import {formatAddress} from '../../../common/format'
import GooglePlacesAutocomplete from '../../../common/components/GooglePlacesAutocomplete'
import config from '../../../config'

class Addresses extends React.Component {

  state = {
    anchorEl: null,
    open: false,
    selected: {},
    selectedKey: 0,
  }

  parsePostalCode = value => {
    const length = value.length
    if (length === 4) return value //numbers
    if (length === 5) return value.slice(1, 5) //first letter + numbers
    if (length === 7) return value.slice(0, 4) //numbers + block letters
    if (length === 8) return value.slice(1, 5) //first letter + numbers + block letters
    return value
  }

  findComponent = (components, type) => {
    for (let i = 0; i < components.length; i++) {
      const types = components[i].types
      const index = types.indexOf(type)
      if (index !== -1) {
        return components[i].long_name
      }
    }
    return ''
  }

  handleSelectSuggest = (suggest) => {
    const components = suggest.address_components
    const street = this.findComponent(components, 'route')
    const postalCode = this.parsePostalCode(this.findComponent(components, 'postal_code'))
    const streetNumber = this.findComponent(components, 'street_number')
    this.props.setPostalCode(postalCode)
    this.props.setStreetNumber(streetNumber)
    this.props.setAddress(street)
    this.props.setOriginal(suggest.formatted_address)
  }

  handleMenuClick = (event, key, address) => {
    this.setState({
      open: true,
      anchorEl: event.currentTarget,
      selected: address,
      selectedKey: key,
    })
  }

  handleMenuClose = () => {
    this.setState({open: false})
  }

  handleMenuEdit = () => {
    this.setState({open: false})
    const selected = this.state.selected
    this.props.edit(
      this.state.selectedKey,
      selected.ID,
      selected.Original,
      selected.Address,
      selected.Number,
      selected.Floor,
      selected.Apartment,
      selected.PostalCode.PostalCode,
    )
  }

  handleMenuRemove = () => {
    this.setState({open: false})
    this.props.remove(this.state.selectedKey, this.state.selected.ID, this.state.selected.Address)
  }

  renderAddress = (key, address, classes) => (
    <PanelItem key={key}>
      <PanelItemText
        primary={formatAddress(address.Address, address.Number, address.Floor, address.Apartment, '')}
        secondary={address.MainAddress === true ? text.mainAddress : ''}
      />
      <ListItemSecondaryAction>
        <IconButton onClick={e => this.handleMenuClick(e, address.ID, address)}><MoreVertIcon/></IconButton>
      </ListItemSecondaryAction>
    </PanelItem>
  )

  render() {
    const {classes, selected} = this.props
    const {emptyFieldErrors} = selected

    return (
      <div className={classes.tabContainer}>
        <Grid container direction="column">
          <Grid item xs={12} safariFix={true}>
            <Typography variant="subheading" style={{fontWeight: 500}}>{text.addresses}</Typography>
          </Grid>
          <Grid item xs={12} safariFix={true}>
            {this.props.addresses.length !== 0
              ? (
                <Panel style={{margin: '0 2px'}}>
                  {this.props.addresses.map((address, key) => this.renderAddress(key, address, classes))}
                </Panel>
              )
              : <Typography variant="body1">{text.noAddresses}</Typography>
            }
          </Grid>
          <Grid item xs={12} safariFix={true}>
            <div style={{textAlign: 'right'}}>
              <Link onClick={this.props.add}>{text.addAddress}</Link>
            </div>
          </Grid>
        </Grid>
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClick={this.handleMenuClose}
        >
          <MenuItem onClick={this.handleMenuEdit}>{text.edit}</MenuItem>
          <MenuItem onClick={this.handleMenuRemove}>{text.remove}</MenuItem>
        </Menu>
        <Dialog
          open={this.props.editDialog}
          onClose={() => this.props.setEditDialogOpen(false)}
        >
          <form>
            <DialogTitle>{text.editDialog.editAddress}</DialogTitle>
            <DialogContent>
              <Grid container>
                <Grid item xs={12}>
                  <GooglePlacesAutocomplete
                    initialValue={this.props.selected.address + ' ' + this.props.selected.number}
                    apiKey={config.GOOGLE_MAPS_API_KEY}
                    searchParams={{componentRestrictions: {country: 'ar'}, language: 'es', type: ['address']}}
                    handleSelectSuggest={suggest => this.handleSelectSuggest(suggest)}
                    inputProps={{
                      autoFocus: true,
                      fullWidth: true,
                      label: text.editDialog.labelAddress,
                      helperText: emptyFieldErrors.address,
                      error: emptyFieldErrors.address.length > 0,
                    }}
                  />
                </Grid>
                {/*<Grid item xs={12} sm={6}>*/}
                {/*  <TextField*/}
                {/*    label={text.addDialog.labelNumber}*/}
                {/*    fullWidth*/}
                {/*    value={this.props.selected.number}*/}
                {/*    onChange={e => this.props.setStreetNumber(e.target.value)}*/}
                {/*    helperText={emptyFieldErrors.number}*/}
                {/*    error={emptyFieldErrors.number.length > 0}*/}
                {/*  />*/}
                {/*</Grid>*/}
                {/*<Grid item xs={12} sm={6}>*/}
                {/*  <TextField*/}
                {/*    label={text.addDialog.labelPostalCode}*/}
                {/*    fullWidth*/}
                {/*    value={this.props.selected.postalCode}*/}
                {/*    onChange={e => this.props.setPostalCode(e.target.value)}*/}
                {/*    helperText={emptyFieldErrors.postalCode}*/}
                {/*    error={emptyFieldErrors.postalCode.length > 0}*/}
                {/*  />*/}
                {/*</Grid>*/}
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={text.editDialog.labelFloor}
                    fullWidth
                    value={this.props.selected.floor}
                    onChange={e => this.props.setFloor(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={text.editDialog.labelApartment}
                    fullWidth
                    value={this.props.selected.apartment}
                    onChange={e => this.props.setApartment(e.target.value)}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.props.setEditDialogOpen(false)}>
                {text.editDialog.cancel}
              </Button>
              <LoadingButton
                color="primary"
                type="submit"
                isLoading={this.props.isLoading}
                onClick={e => {
                  e.preventDefault()
                  this.props.saveEdit(this.state.selectedKey)
                }}
              >
                {text.editDialog.accept}
              </LoadingButton>
            </DialogActions>
          </form>
        </Dialog>
        <Dialog
          open={this.props.removeDialog}
          onClose={() => this.props.setRemoveDialogOpen(false)}
        >
          <DialogTitle>{text.removeDialog.removeAddress}</DialogTitle>
          <DialogContent>
            <DialogContentText>{text.removeDialog.areYouSure}</DialogContentText>
            <DialogContentText style={{marginTop: 10}}>{this.props.selected.address}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.props.setRemoveDialogOpen(false)}>
              {text.removeDialog.cancel}
            </Button>
            <LoadingButton
              color="primary"
              isLoading={this.props.isLoading}
              onClick={() => this.props.saveRemove(this.state.selectedKey)}
            >
              {text.removeDialog.accept}
            </LoadingButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.props.addDialog}
          onClose={() => this.props.setAddDialogOpen(false)}
        >
          <form>
            <DialogTitle>{text.addDialog.addAddress}</DialogTitle>
            <DialogContent>
              <Grid container>
                <Grid item xs={12}>
                  <GooglePlacesAutocomplete
                    apiKey={config.GOOGLE_MAPS_API_KEY}
                    searchParams={{componentRestrictions: {country: 'ar'}, language: 'es', type: ['address']}}
                    handleSelectSuggest={suggest => this.handleSelectSuggest(suggest)}
                    inputProps={{
                      autoFocus: true,
                      fullWidth: true,
                      label: text.addDialog.labelAddress,
                      helperText: emptyFieldErrors.address,
                      error: emptyFieldErrors.address.length > 0,
                    }}
                  />
                </Grid>
                {/*<Grid item xs={12} sm={6}>*/}
                {/*  <TextField*/}
                {/*    label={text.addDialog.labelNumber}*/}
                {/*    fullWidth*/}
                {/*    value={this.props.selected.number}*/}
                {/*    onChange={e => this.props.setStreetNumber(e.target.value)}*/}
                {/*    helperText={emptyFieldErrors.number}*/}
                {/*    error={emptyFieldErrors.number.length > 0}*/}
                {/*  />*/}
                {/*</Grid>*/}
                {/*<Grid item xs={12} sm={6}>*/}
                {/*  <TextField*/}
                {/*    label={text.addDialog.labelPostalCode}*/}
                {/*    fullWidth*/}
                {/*    value={this.props.selected.postalCode}*/}
                {/*    onChange={e => this.props.setPostalCode(e.target.value)}*/}
                {/*    helperText={emptyFieldErrors.postalCode}*/}
                {/*    error={emptyFieldErrors.postalCode.length > 0}*/}
                {/*  />*/}
                {/*</Grid>*/}
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={text.addDialog.labelFloor}
                    fullWidth
                    value={this.props.selected.floor}
                    onChange={e => this.props.setFloor(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={text.addDialog.labelApartment}
                    fullWidth
                    value={this.props.selected.apartment}
                    onChange={e => this.props.setApartment(e.target.value)}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.props.setAddDialogOpen(false)}>
                {text.addDialog.cancel}
              </Button>
              <LoadingButton
                color="primary"
                type="submit"
                isLoading={this.props.isLoading}
                onClick={e => {
                  e.preventDefault()
                  this.props.saveAdd()
                }}
              >
                {text.addDialog.accept}
              </LoadingButton>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    )
  }
}

Addresses.propTypes = {}

export default Addresses



// WEBPACK FOOTER //
// ./src/sections/profile/components/Addresses.js